import { createContext, useContext } from 'react';

const GoalHomePageInfoContext = createContext({});

export const HomePageInfoContextProvider = GoalHomePageInfoContext.Provider;
export const useGoalHomePageInfo = () => useContext(GoalHomePageInfoContext);
